import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { getFormattedValue } from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

interface MemberTagCardProps {
  params: Record<string, string>;
  url: string;
}

interface MemberTagFieldConfig {
  defaultValue?: string;
  label: string;
  type: string;
}

export const MemberTagCard = ({ params, url }: MemberTagCardProps) => {
  const MEMBER_TAG_FIELDS: Record<string, MemberTagFieldConfig> = {
    name: { label: t("settings.member_tags.name"), type: "string" },
    color: {
      label: t("settings.member_tags.design.is_background_enabled"),
      type: "string",
    },
    is_public: {
      label: t("settings.member_tags.visibility.is_public"),
      type: "boolean",
    },
    display_locations: {
      label: t("settings.member_tags.visibility.display_locations.title"),
      type: "string",
    },
    display_format: {
      label: t("settings.member_tags.visibility.display_format.title"),
      type: "string",
      defaultValue: t("settings.member_tags.visibility.display_format.label"),
    },
  };

  return (
    <PreviewCardLayout
      title={t(
        "help_widget.copilot.preview_cards.create_member_tag_card_title",
      )}
      url={url}
    >
      <ul className="flex flex-col leading-5">
        {Object.entries(MEMBER_TAG_FIELDS).map(([key, keyProps]) => {
          const hasValueInParams = key in params && params[key] != null;
          const value = hasValueInParams ? params[key] : keyProps.defaultValue;

          return (
            value != null && (
              <li key={key} className="text-darkest !pb-0">
                <Typography.BodySm color="text-darkest">
                  <strong>{keyProps.label}:</strong>{" "}
                  {getFormattedValue(value, keyProps.type)}
                </Typography.BodySm>
              </li>
            )
          );
        })}
      </ul>
    </PreviewCardLayout>
  );
};
